import api from "./api";

const route = "/payment_methods";

export default {
  getPaymentMethods: () => api.get(route),
};
